// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getMessaging, onMessage, getToken } from "firebase/messaging";
// import { useParams } from "react-router-dom";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// shyam
const firebaseConfig = {
  apiKey: "AIzaSyC4NpHZcbQp64VHrH6Z7Buh7dQE8cDoA_Q",
  authDomain: "dukanbuddy-6c00b.firebaseapp.com",
  projectId: "dukanbuddy-6c00b",
  storageBucket: "dukanbuddy-6c00b.appspot.com",
  messagingSenderId: "1006339594921",
  appId: "1:1006339594921:web:1068cd5bdde3cd6da4e7b8",
  measurementId: "G-1FCGT9NF0V",
};
// Initialize Firebase
export const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const messaging = getMessaging(app);

const provider = new GoogleAuthProvider();
export { auth, provider };
export const requestForToken = async () => {
  try {
    if (Notification.permission !== "granted" && Notification.permission !== "default") {
      // console.log("Notification permission is blocked or denied.");
      return null;
    }

    const currentToken = await getToken(messaging, {
      vapidKey:
        "BMvG8LxEueFazBaYYFVPMeBsCd6B1v4k1kOCJ_-4rsn2eQ24v6ZXeFClmaJ-gEAFsQpLqq4pQtXD18BnQXUA-bI",
    });

    if (currentToken) {
      localStorage.setItem("f_token", currentToken);
      return currentToken;
    } else {
      // console.log("No registration token available.");
      return null;
    }
  } catch (err) {
    console.error("Error retrieving FCM token:", err);
    return null;
  }
};
export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      // console.log("payload", payload);
      resolve(payload);
    });
  });
